import { Outlet } from 'react-router-dom';
import BottomNav from './BottomNav';

const AppLayout = () => {
  return (
    <div className="min-h-screen w-full bg-surface-50 dark:bg-surface-950">
      <BottomNav />
      <div className="lg:pl-[240px]">
        <Outlet />
      </div>
    </div>
  );
};

export default AppLayout;
